import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import deCommon from './locales/de/common.json';
import enLegal from './locales/en/legal.json';
import deLegal from './locales/de/legal.json';
import enInspire from './locales/en/inspire.json';
import deInspire from './locales/de/inspire.json';
import enHire from './locales/en/hire.json';
import deHire from './locales/de/hire.json';
import enMessages from './locales/en/messages.json';
import deMessages from './locales/de/messages.json';
import enRecruiterInbox from './locales/en/recruiterInbox.json';
import deRecruiterInbox from './locales/de/recruiterInbox.json';
import enProfile from './locales/en/profile.json';
import deProfile from './locales/de/profile.json';
import enRecruiterProfile from './locales/en/recruiterProfile.json';
import deRecruiterProfile from './locales/de/recruiterProfile.json';
import enAboutUs from './locales/en/aboutUs.json';
import deAboutUs from './locales/de/aboutUs.json';
import enPricing from './locales/en/pricing.json';
import dePricing from './locales/de/pricing.json';
import enMaintenance from './locales/en/maintenance.json';
import deMaintenance from './locales/de/maintenance.json';
import enCommunity from './locales/en/community.json';
import deCommunity from './locales/de/community.json';
import enCompanyExplore from './locales/en/companyExplore.json';
import deCompanyExplore from './locales/de/companyExplore.json';
import enCompanyManage from './locales/en/companyManage.json';
import deCompanyManage from './locales/de/companyManage.json';
import enInterestedFeed from './locales/en/interestedFeed.json';
import deInterestedFeed from './locales/de/interestedFeed.json';
import enCareers from './locales/en/careers.json';
import deCareers from './locales/de/careers.json';
import enSpotlights from './locales/en/spotlights.json';
import deSpotlights from './locales/de/spotlights.json';
import enHiringBoard from './locales/en/hiringBoard.json';
import deHiringBoard from './locales/de/hiringBoard.json';
import enPassport from './locales/en/passport.json';
import dePassport from './locales/de/passport.json';
import enPassportShare from './locales/en/passportShare.json';
import dePassportShare from './locales/de/passportShare.json';
import enHelpAshby from './locales/en/helpAshby.json';
import deHelpAshby from './locales/de/helpAshby.json';
import enWatch from './locales/en/watch.json';
import deWatch from './locales/de/watch.json';
import enJobRadarAi from './locales/en/jobRadarAi.json';
import deJobRadarAi from './locales/de/jobRadarAi.json';

const resources = {
  en: {
    common: enCommon,
    legal: enLegal,
    inspire: enInspire,
    hire: enHire,
    messages: enMessages,
    recruiterInbox: enRecruiterInbox,
    profile: enProfile,
    recruiterProfile: enRecruiterProfile,
    aboutUs: enAboutUs,
    pricing: enPricing,
    maintenance: enMaintenance,
    community: enCommunity,
    companyExplore: enCompanyExplore,
    companyManage: enCompanyManage,
    interestedFeed: enInterestedFeed,
    careers: enCareers,
    spotlights: enSpotlights,
    hiringBoard: enHiringBoard,
    passport: enPassport,
    passportShare: enPassportShare,
    helpAshby: enHelpAshby,
    watch: enWatch,
    jobRadarAi: enJobRadarAi
  },
  de: {
    common: deCommon,
    legal: deLegal,
    inspire: deInspire,
    hire: deHire,
    messages: deMessages,
    recruiterInbox: deRecruiterInbox,
    profile: deProfile,
    recruiterProfile: deRecruiterProfile,
    aboutUs: deAboutUs,
    pricing: dePricing,
    maintenance: deMaintenance,
    community: deCommunity,
    companyExplore: deCompanyExplore,
    companyManage: deCompanyManage,
    interestedFeed: deInterestedFeed,
    careers: deCareers,
    spotlights: deSpotlights,
    hiringBoard: deHiringBoard,
    passport: dePassport,
    passportShare: dePassportShare,
    helpAshby: deHelpAshby,
    watch: deWatch,
    jobRadarAi: deJobRadarAi
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
      format: (value, format, lng) => {
        if (format === 'number' && typeof value === 'number') {
          const locale = lng?.startsWith('de') ? 'de-DE' : 'en-US';
          return value.toLocaleString(locale);
        }
        return value as string;
      },
    },
    defaultNS: 'common',
    ns: ['common', 'legal', 'inspire', 'hire', 'messages', 'recruiterInbox', 'profile', 'recruiterProfile', 'aboutUs', 'pricing', 'maintenance', 'community', 'companyExplore', 'companyManage', 'interestedFeed', 'careers', 'spotlights', 'hiringBoard', 'passport', 'passportShare', 'helpAshby', 'watch', 'jobRadarAi']
  });

export default i18n;


